import { Button, Container, Typography } from "@material-ui/core"
import dynamic from "next/dynamic"
import { Dispatch, SetStateAction, useEffect } from "react"
import styled from "styled-components"
import glass from "../../public/animation/glass.json"

const Lottie = dynamic(() => import("lottie-react"), { ssr: false })

const StyledWrapper = styled(Container)`
  height: 100vh;
`

const StyledTitle = styled(Typography).attrs({ variant: "h1" })`
  font-size: 50px;
  margin-top: 35px;
  line-height: 0.8;
  color: #000;
`

const StyledText = styled(Typography).attrs({ variant: "body1" })`
  margin-top: 10px;
  line-height: 0.92;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 22px;
  }
`

const StyledButton = styled(Button).attrs({ variant: "contained" })`
  width: 158px;
  height: 48px;
  background-color: #ffb900;
  color: black;
  font-size: 24px;
  font-family: "NarkisBlock", sans-serif;
  margin-top: 40px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
  }
`

const StyledLottie = styled(Lottie)`
  height: 50%;
`
type FailurePageProps = {
  setCompaniesSteps: Dispatch<SetStateAction<number>>
}

const FailurePage = ({ setCompaniesSteps }: FailurePageProps) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <StyledWrapper>
      <StyledLottie animationData={glass} loop={false} />
      <StyledTitle>אופסי, משהו השתבש בדרך</StyledTitle>
      <StyledText>
        העמוד שחיפשת לא קיים או שיש כרגע בעיה זמנית להגיע אליו
      </StyledText>
      <StyledButton onClick={() => setCompaniesSteps(1)}>
        בואו ננסה שוב
      </StyledButton>
    </StyledWrapper>
  )
}

export default FailurePage
